<template>
  <div>
    <NavBar></NavBar>
    <router-view></router-view>
  </div>
</template>

<script>
import NavBar from './components/Community/NavBar.vue';
export default {
  name:'app',
  components: {
    NavBar,
  },
}
</script>